export default {
	path: '/schoolHome',
	name: 'schoolHome',
	component: () => import('@/views/school/schoolHome'),
	children: [{
			path: 'login',
			component: () => import('@/views/school/login'),
		},
		{
			path: 'projectList',
			component: () => import('@/views/school/projectList'),
		},
		{
			path: 'projectRecord',
			component: () => import('@/views/school/projectRecord'),
		},
		{
			path: 'confirmList',
			component: () => import('@/views/school/confirmList'),
		},
		{
			path: 'confirmRecord',
			component: () => import('@/views/school/confirmRecord'),
		},
		{
			path: 'homepage',
			component: () => import('@/views/school/homepage'),
		},
	]
}